module.exports = __webpack_public_path__ + "static/media/comfortaa-variablefont_wght-webfont.d92b4b35.woff";